<template>
  <div>
    <ClassicButton
      classButton="button tertiaryButton button-score flex justify-between"
      flexOption="m-2"
      @buttonClick="showModal = true"
    >
      <template v-slot:ButtonContent>
        {{ initDetail.line }}
        <span class="score"  v-if="showLineScore">
          <span v-if="initDetail.score != ''">{{ initDetail.score }}</span>
          <span v-else class="opacity-10">-</span>
          </span>
      </template>
    </ClassicButton>
    <Modal :showModal="showModal">
      <template v-slot:modalHeader>
        <button
          @click.prevent="showModal = !showModal"
          type="button"
          title="fermer"
          :class="'modal-header color-' + backGroundColor"
        >
          &times;
        </button>
      </template>
      <template v-slot:modalBody>
        <div class=" modal-body  container ">
          <div class="flex">
            <button
              type="button"
              class="ml-auto rounded-full p-2  block   "
              @click.prevent="showModal = false"
            >
              <span
                class="uppercase font-bold text-3xl leading-none text-gray-600 "
                >&times;</span
              >
            </button>
          </div>
          <div class="">
            <h2 class="modal-title">
              {{ detail.player }} &rsaquo; {{ detail.line }}
            </h2>

            <form @submit.prevent="showModal = false">
              <div class=" flex justify-around  ">
                <ClassicButton
                  label="+1"
                  classButton="button primaryButton button-large"
                  @buttonClick="incrementScore(1)"
                />
                <ClassicButton
                  label="+5"
                  classButton="button primaryButton button-large"
                  @buttonClick="incrementScore(5)"
                />
                <ClassicButton
                  label="+10"
                  classButton="button primaryButton button-large"
                  @buttonClick="incrementScore(10)"
                />
                <ClassicButton
                  label="+100"
                  classButton="button primaryButton button-large"
                  @buttonClick="incrementScore(100)"
                />
              </div>

              <div class="p-4">
                <input
                  pattern="(-)?\d*"
                  class="input-text input-score"
                  v-model="detail.score"
                  :placeholder="'Score pour ' + detail.line"
                />
              </div>

              <div class="flex justify-around  ">
                <ClassicButton
                  label="-100"
                  classButton="button secondaryButton button-large"
                  @buttonClick="incrementScore(-100)"
                />

                <ClassicButton
                  label="-10"
                  classButton="button secondaryButton button-large"
                  @buttonClick="incrementScore(-10)"
                />

                <ClassicButton
                  label="-5"
                  classButton="button secondaryButton button-large"
                  @buttonClick="incrementScore(-5)"
                />

                <ClassicButton
                  label="-1"
                  classButton="button secondaryButton button-large"
                  @buttonClick="incrementScore(-1)"
                />
              </div>
            </form>
            <div class="flex mt-8">
              <ClassicButton
                label="Fermer"
                classButton="button tertiaryButton button-large"
                @buttonClick="showModal = false"
              />
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/ui/generic/Modal.vue";
import ClassicButton from "@/components/ui/form/button/ClassicButton.vue";

export default {
  name: "easyscore",
  props: {
    initDetail: {
      type: Object,
      required: true,
      default() {
        return {
          line: "",
          player: "",
          score: ""
        };
      }
    },
    backGroundColor: {
      type: String,
      required: false,
      default: "gray"
    },
    showLineScore: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      showModal: false,
      detail: {}
    };
  },
  components: {
    Modal,
    ClassicButton
  },
  methods: {
    incrementScore: function(value) {
      var result = Number(this.detail.score) + value;
      if (!isNaN(Number(this.detail.score))) {
        this.detail.score = result.toString();
      } else {
        this.detail.score = "";
      }
      //this.detail.score = result.toString();
      this.$emit("update", this.detail.score);
    }
  },
  mounted() {
    // this.detail = this.initDetail
  },

  watch: {
    showModal: {
      handler() {
        if (this.showModal) {
          this.detail = this.initDetail;
          this.$emit("showModal", true);
        } else {
          this.$emit("hideModal", true);
        }
      },
      deep: true
    }
  }
};
</script>
